module.exports = __webpack_public_path__ + "img/faq.9c17d95.svg";